import React from "react";
import { Button, Stack } from "@mui/material";
import { useSelector } from "react-redux";
import { IExpand } from "../../../../types/expand.type";
import { useAlertContext } from "../../../../contexts/alert/AlertProvider";
import { asyncDelete } from "../../../../utils/httpRequests";
import WrapperExpand from "../WrapperExpand";
import Tabbase from "../../tab/Tabbase";
import InfoSection from "./info-section/InfoSection";
import PhanQuyenSection from "./phanquyen-section/PhanQuyenSection";

function ExpandUsergroup({ data, onOpenEdit, setLoad }: IExpand) {
  const { token, profile } = useSelector((state: any) => state.auth);
  const { showAlert } = useAlertContext();

  const allowEditAndDelete =
    profile?.admin_app || profile?.email === data?.user_created;

  const handleDelete = async () => {
    const resp = await asyncDelete({
      apiCode: "usergroup",
      id: data?._id,
      token,
    });
    if (resp?.status !== 200) {
      showAlert({
        type: "error",
        message:
          resp?.data?.error || resp?.data?.message || "Lỗi khi xóa dữ liệu",
      });
    } else {
      showAlert({ type: "success", message: `Đã xóa thành công` });
      setLoad?.((prev) => prev + 1);
    }
  };

  return (
    <WrapperExpand
      sx={{ py: 0 }}
      data={data}
      action={
        allowEditAndDelete ? (
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            gap={1}
            sx={{ py: 1 }}
          >
            <Button
              onClick={onOpenEdit}
              variant="contained"
              size="small"
              sx={{
                boxShadow: "none",
                textTransform: "none",
                color: "common.white",
                "&:hover": {
                  boxShadow: "none",
                },
              }}
            >
              Chỉnh sửa
            </Button>
            <Button
              onClick={() => {
                showAlert({
                  title: "Xác nhận xóa",
                  type: "info",
                  message: "Bạn có chắc muốn xóa dòng này không ?",
                  onConfirm: handleDelete,
                });
              }}
              variant="contained"
              size="small"
              color="error"
              sx={{
                boxShadow: "none",
                textTransform: "none",
                color: "common.white",
                "&:hover": {
                  boxShadow: "none",
                },
              }}
            >
              Xóa
            </Button>
          </Stack>
        ) : null
      }
    >
      <Tabbase
        tabs={[
          { label: "Thông tin chung", value: "1" },
          { value: "2", label: "Phân quyền" },
        ]}
        panels={[
          { value: "1", content: <InfoSection data={data} /> },
          { value: "2", content: <PhanQuyenSection data={data} /> },
        ]}
      />
    </WrapperExpand>
  );
}

export default ExpandUsergroup;
